import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';

function getAProp(obj) {
  if (obj.Name) return obj.Name;
  if (obj.Id) return obj.Id;
  if (obj.id) return obj.id;

  for (var p in obj) {
    if (typeof obj[p] === 'string') return obj[p];
  }

  return 'Data';
}

var GridViewObjectFormatter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridViewObjectFormatter, _React$Component);

  function GridViewObjectFormatter() {
    _classCallCheck(this, GridViewObjectFormatter);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridViewObjectFormatter).apply(this, arguments));
  }

  _createClass(GridViewObjectFormatter, [{
    key: "render",
    value: function render() {
      var text = getAProp(this.props.data);
      return text;
    }
  }]);

  return GridViewObjectFormatter;
}(React.Component);

export default GridViewObjectFormatter;